import LoginSubmitButton from "./LoginSubmitButton";
import { FC, FormEvent } from "react";
import { Field } from "@cluey/cluey-components";

interface LoginEmailStepProps {
  email: string;
  error: string | false;
  loading: boolean;
  submitLabel: string;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onEmailChange: (value: string) => void;
}

const LoginEmailStep: FC<LoginEmailStepProps> = ({ email, error, loading, submitLabel, onSubmit, onEmailChange }) => (
  <form onSubmit={onSubmit} className="flex w-full flex-col items-start gap-10 md:gap-12">
    <h1 className="max-w-md font-display text-[28px] leading-10 sm:text-[32px]">Log in or sign up</h1>
    <div>
      <Field
        label="Email"
        name="email"
        value={email}
        onChange={onEmailChange}
        type="email"
        className="w-full max-w-sm [&_input]:rounded-full"
        error={error}
        disabled={loading}
      />
      <div className="text-grey-400 text-sm mt-1">We will create an account for you if you don't have one yet</div>
    </div>
    <LoginSubmitButton loading={loading} label={submitLabel} disabled={!email} />
  </form>
);

export default LoginEmailStep;